import api from './api';

export interface LoginPayload { email: string; password: string; }
export interface SsoExchangePayload { token: string; }

export const authService = {
    login: (data: LoginPayload) => api.post('/auth/login', data),
    refresh: (refreshToken: string) => api.post('/auth/refresh', { refreshToken }),
    ssoLink: () => api.post('/auth/sso-link'),
    ssoExchange: (data: SsoExchangePayload) => api.post('/auth/sso-exchange', data),
    logout: () => api.post('/auth/logout').catch(() => undefined),
    me: () => api.get('/auth/me').catch(() => undefined),
};
